export default class DigitalMarketing {
    constructor(rawData = {}) {
      this.id = rawData.id;
      this.type = rawData.type
      this.code = rawData.code
    }
  }